/*******************************************************************************
CONDITIONALLY ADD THE SEARCH FEATURE
Only certain sports (with lots of links) will need the search feature so this
adds it to only those sports.
*******************************************************************************/

export default function addSearchFeature() {
    if ($('.side-nav__search').length > 0) { return; }

    const numLinks = $('.is-section .side-nav__item').length;
    const numSections = $('.is-section .side-nav__sub-section').length;
    const contentName = $('.top-nav-section__item.is-active').text();

    // Add search to this sport nav if it has enough links and/or sections
    if (numLinks >= 50 || numSections >= 10) {
        const searchHTML = `
        <div class="side-nav__actions is-section">
            <div class="side-nav__search-wrap">
                <label for="sidenav-search" class="side-nav__search-label">Search ${contentName} Pages</label>
                <input id="sidenav-search" class="side-nav__search" type="text" value="" placeholder="Find A Page">
                <div class="side-nav__clear-search hide">&times;</div>
            </div>
        </div>`;
        $('.side-nav__middle').before(searchHTML);
    }
}
